
import * as angular from 'angular';
import { NgModule } from 'ng-metadata/core';
import { ResizerComponent } from './resizer.component';
import { TouchStartDirective } from './touch-start.directive';

/**
 * @ngdoc module
 * @name mw.components.resizer
 * @description
 *
 * Resizer
 */
@NgModule({
    declarations: [ ResizerComponent, TouchStartDirective ]
})
export class ResizerModule {}



// WEBPACK FOOTER //
// ./src/lib/components/resizer/resizer.module.ts